import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const LABELS = {
  "/": "Accueil",
  "/wallonie": "Wallonie",
  "/simulateur": "Simulateur Rénopack",
  "/certificat-peb": "Certificat PEB",
  "/estimation": "Ancien simulateur",
  "/confidentialite": "Confidentialité",
  "Google Lead Forms": "Formulaires Google Ads",
};

const pct = (v) => (v === null || v === undefined ? "—" : `${v}%`);

export const PagePerfTable = ({ data }) => (
  <div className="bg-white border border-slate-200 rounded-xl overflow-hidden" data-testid="page-perf-table">
    <div className="px-4 py-3 border-b border-slate-100">
      <h2 className="font-semibold text-slate-900 text-base">Performance par page</h2>
      <p className="text-xs text-slate-500">
        Visites, leads, appels et verdicts de votre client. Les visites sont conservées 90 jours. Conversion = (leads + appels) / visites.
      </p>
    </div>
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Page</TableHead>
          <TableHead className="text-right">Visites</TableHead>
          <TableHead className="text-right">Leads</TableHead>
          <TableHead className="text-right">Appels</TableHead>
          <TableHead className="text-right">Taux leads</TableHead>
          <TableHead className="text-right">Taux appels</TableHead>
          <TableHead className="text-right">Conversion</TableHead>
          <TableHead className="text-right">Validés</TableHead>
          <TableHead className="text-right">Pas qualifiés</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.by_page.map((p) => (
          <TableRow key={p.page} data-testid={`page-perf-row-${p.page}`}>
            <TableCell>
              <p className="font-medium text-slate-900">{LABELS[p.page] || p.page}</p>
              {p.page.startsWith("/") && <p className="text-xs text-slate-400">{p.page}</p>}
            </TableCell>
            <TableCell className="text-right">{p.pageviews}</TableCell>
            <TableCell className="text-right">{p.leads_total}</TableCell>
            <TableCell className="text-right">{p.calls}</TableCell>
            <TableCell className="text-right">{pct(p.lead_rate)}</TableCell>
            <TableCell className="text-right">{pct(p.call_rate)}</TableCell>
            <TableCell className="text-right font-semibold text-slate-900">{pct(p.conv_rate)}</TableCell>
            <TableCell className="text-right text-green-700">{p.validated}</TableCell>
            <TableCell className="text-right text-red-600">{p.unqualified}</TableCell>
          </TableRow>
        ))}
        <TableRow className="bg-slate-50 font-semibold" data-testid="page-perf-total">
          <TableCell>Total</TableCell>
          <TableCell className="text-right">{data.summary.total_pageviews}</TableCell>
          <TableCell className="text-right">{data.summary.total_leads}</TableCell>
          <TableCell className="text-right">{data.summary.total_calls}</TableCell>
          <TableCell className="text-right">{pct(data.summary.lead_rate)}</TableCell>
          <TableCell className="text-right">{pct(data.summary.call_rate)}</TableCell>
          <TableCell className="text-right">{pct(data.summary.conv_rate)}</TableCell>
          <TableCell className="text-right text-green-700">{data.summary.total_validated}</TableCell>
          <TableCell className="text-right text-red-600">{data.summary.total_unqualified}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </div>
);
